import { useState } from 'react';
import { getImportShim } from '@/utils/app-bundles';
import { useMountEffect } from './state/use-mount-effect';

async function load() {
  Object.assign(window, {
    esmsInitOptions: {
      // Enable Shim Mode
      shimMode: true,
      // Permit overrides to import maps
      mapOverrides: true,
    },
  });

  // oxlint-disable-next-line typescript/ban-ts-comment
  // @ts-ignore
  await import('es-module-shims');
  getImportShim();
}

export function useLoadShims() {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  if (error != null) {
    throw error;
  }

  useMountEffect(() => {
    load()
      .then(() => setLoaded(true))
      .catch((loadError: unknown) => {
        setError(loadError instanceof Error ? loadError : new Error('Failed to initialize embedded app shims.'));
      });
  });

  return loaded;
}
